import {
  LayoutDashboard,
  Package,
  Users,
  Truck,
  Box,
  FileText,
  ClipboardList,
  FileCheck,
  Receipt,
  RotateCcw,
  ArrowDownCircle,
  ArrowUpCircle,
  Zap,
  ShoppingCart,
  ShoppingBag,
  PackageCheck,
  Minus,
  IndianRupee,
  Landmark,
  RefreshCw,
  Download,
  CreditCard,
  Star,
  UserCheck,
  ListTodo,
  DollarSign,
  MapPin,
  Route,
  ClipboardCheck,
  AlertTriangle,
  BarChart2,
  TrendingUp,
  Target,
  Bell,
  Settings,
  FileCode,
  Shield,
  Sliders,
  Home,
  Store,
  Wallet,
  UserCog,
  HelpCircle,
  LogOut,
  ChevronDown,
  ChevronRight,
  User,
  Clock,
  Calendar,
  PieChart,
  CheckSquare,
  Repeat,
  MinusCircle,
  BarChart3
} from 'lucide-react';

/**
 * Maps icon string names from the backend API to actual Lucide React icon components.
 * This allows the backend to control which icons are displayed without frontend changes.
 */
export const ICON_MAP = {
  // Dashboard & Home
  LayoutDashboard,
  Home,
  
  // Catalogue
  Package,
  Box,
  Users,
  Truck,
  Store,
  
  // Sales & POS
  ShoppingCart,
  FileText,
  ClipboardList,
  FileCheck,
  Receipt,
  RotateCcw,
  ArrowDownCircle,
  ArrowUpCircle,
  Zap,
  
  // Purchases
  ShoppingBag,
  PackageCheck,
  Minus,
  
  // Finance & Billing
  IndianRupee,
  Landmark,
  RefreshCw,
  Download,
  CreditCard,
  Star,
  Wallet,
  DollarSign,
  Repeat,
  MinusCircle,
  
  // Team & Operations
  UserCheck,
  UserCog,
  ListTodo,
  
  // Field Tracking
  MapPin,
  Route,
  ClipboardCheck,
  AlertTriangle,
  Clock,
  Calendar,
  
  // Intelligence & Reports
  BarChart2,
  BarChart3,
  TrendingUp,
  Target,
  Bell,
  PieChart,
  CheckSquare,
  
  // Settings
  Settings,
  FileCode,
  Shield,
  Sliders,
  
  // User & Auth
  User,
  HelpCircle,
  LogOut,
  
  // Navigation
  ChevronDown,
  ChevronRight
};

/**
 * Get a Lucide React icon component by its string name.
 * Returns LayoutDashboard as fallback if icon not found.
 * 
 * @param {string} iconName - The name of the icon (e.g., "LayoutDashboard", "Users")
 * @returns {React.Component} The Lucide React icon component
 */
export const getIcon = (iconName) => {
  if (!iconName) return LayoutDashboard;
  
  // Direct lookup
  if (ICON_MAP[iconName]) {
    return ICON_MAP[iconName];
  }
  
  // Try case-insensitive lookup
  const lowerName = iconName.toLowerCase();
  const matchingKey = Object.keys(ICON_MAP).find(
    key => key.toLowerCase() === lowerName
  );
  
  if (matchingKey) {
    return ICON_MAP[matchingKey];
  }
  
  // Fallback
  console.warn(`[iconMapping] Unknown icon: ${iconName}, using fallback`);
  return LayoutDashboard;
};

export default getIcon;
